import { Helmet } from 'react-helmet'
import { PageTypes } from 'src/typings/pageTypes'
import { getDynamicYieldInlineConsentScript } from 'src/utils/dynamicYieldConsent'
import { getDynamicYieldContext } from 'src/utils/getDynamicYieldContext'
import { api } from '../../../store.config'

export const DYNAMIC_YIELD_API_DYNAMIC_SCRIPT_URL = `https://cdn-eu.dynamicyield.com/api/${api.dynamicYieldSectionId}/api_dynamic.js`
export const DYNAMIC_YIELD_API_STATIC_SCRIPT_URL = `https://cdn-eu.dynamicyield.com/api/${api.dynamicYieldSectionId}/api_static.js`

export const DynamicYieldPreconnect = () => (
  <>
    {/* Il preconnect viene aggiunto durante SSR in gatsby-ssr. Non chiama DY:
        apre solo prima le connessioni per velocizzare il load script client. */}
    <link
      key="dynamic-yield-preconnect-cdn"
      rel="preconnect"
      href="https://cdn-eu.dynamicyield.com"
    />
    <link
      key="dynamic-yield-preconnect-st"
      rel="preconnect"
      href="https://st-eu.dynamicyield.com"
    />
    <link
      key="dynamic-yield-preconnect-rcom"
      rel="preconnect"
      href="https://rcom-eu.dynamicyield.com"
    />
  </>
)

type DynamicYieldHeadBootstrapProps = {
  pathname?: string
  productSku?: string | null
  categoryPath?: string[]
  pageType?: PageTypes
}

const serializeForInlineScript = (value: unknown) =>
  JSON.stringify(value).replace(/</g, '\\u003c')

export const DynamicYieldHeadBootstrap = ({
  pathname = '/',
  productSku = null,
  categoryPath = [],
  pageType = PageTypes.NotSet,
}: DynamicYieldHeadBootstrapProps) => {
  const recommendationContext = getDynamicYieldContext({
    pathname,
    productSku,
    categoryPath,
    pageType,
  })

  return (
    <Helmet>
      <script
        key="dynamic-yield-context"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
            window.DY = window.DY || {};
            window.DY.recommendationContext = ${serializeForInlineScript(
              recommendationContext
            )};
            ${getDynamicYieldInlineConsentScript()}
          `,
        }}
      />
      <script
        key="dynamic-yield-api-dynamic"
        async
        type="text/javascript"
        data-dynamic-yield-script="api_dynamic"
        src={DYNAMIC_YIELD_API_DYNAMIC_SCRIPT_URL}
      />
      <script
        key="dynamic-yield-api-static"
        async
        type="text/javascript"
        data-dynamic-yield-script="api_static"
        src={DYNAMIC_YIELD_API_STATIC_SCRIPT_URL}
      />
      <script
        key="dynamic-yield-consent"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
            window.DYO && window.DYO.ActiveConsent && window.DYO.ActiveConsent.updateConsentAcceptedStatus && window.DYO.ActiveConsent.updateConsentAcceptedStatus(Boolean(window.DY && window.DY.userActiveConsent && window.DY.userActiveConsent.accepted));
          `,
        }}
      />
    </Helmet>
  )
}
